import { app } from '@ibgroup-tws-webapps/ratio.ui';

export interface VibrationPattern {
  /** Time offset in seconds */
  t: number;
  /** Intensity (0.0 to 1.0) */
  i: number;
  /** Sharpness (0.0 to 1.0) */
  s: number;
}

const DEFAULT_VIBRATION_PATTERN: VibrationPattern[] = [{ t: 0.001, i: 0.4, s: 0.2 }];

export function useHaptics() {
  /**
   * @param pattern - Array of vibration pattern objects, defaults to a single quick tap
   */
  const triggerVibration = (pattern: VibrationPattern[] = DEFAULT_VIBRATION_PATTERN) => {
    if (navigator.vibrate && app.option.hapticVersion === 1) {
      navigator.vibrate(pattern as unknown as VibratePattern);
    }
  };

  return {
    triggerVibration,
  };
}

export default useHaptics;
